import React from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import Particles from "react-particles-js";

import "./styles.scss";

import photoMiguel from "../../assets/images/miguel.png";
import photoNuno from "../../assets/images/nuno.png";
import photoVasco from "../../assets/images/vasco.png";
import photoLuis from "../../assets/images/luis.png";

import photoDonation1 from "../../assets/images/donation1.png";
import photoDonation2 from "../../assets/images/donation2.png";
import photoDonation3 from "../../assets/images/donation3.png";

import cardanoLogoC1 from "../../assets/svg/cardano_color1.svg";
import cardanoLogoC2 from "../../assets/svg/cardano_color2.svg";
import linkedinLogo from "../../assets/svg/linkedin-icon-2.svg";

class LandingPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            contactName: "",
            contactEmail: "",
            contactMessage: "",
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    sendEmail() {
        toast.error("In development");
        return;

        const { contactName, contactEmail, contactMessage } = this.state;
        if (contactName === "") {
            toast.error("Please insert your full name");
            return;
        }

        if (contactEmail === "") {
            toast.error("Please insert your email");
            return;
        }

        if (contactMessage === "") {
            toast.error("Please insert your message");
            return;
        }
        console.log("contactName", contactName);
        console.log("contactEmail", contactEmail);
        console.log("contactMessage", contactMessage);
    }

    renderMainSection() {
        return (
            <div className="MainSectionWrapper">
                <Particles
                    params={{
                        particles: {
                            number: {
                                value: 50,
                            },
                            size: {
                                value: 3,
                            },
                            move: {
                                speed: 0.5,
                            },
                        },
                        interactivity: {
                            events: {
                                onhover: {
                                    enable: true,
                                    mode: "grab",
                                },
                            },
                        },
                    }}
                />
                <div className="LeftWrapper">
                    <h1 className="MainSectionHeader">Logo</h1>
                </div>
                <div className="Divider" />
                <div className="RightWrapper">
                    <h1 className="MainSectionHeader">Slogan</h1>
                </div>
            </div>
        );
    }

    renderWhatIsSection() {
        return (
            <div className="WhatIsWrapper">
                <div className="WrapperWrapper">
                    <img className="Logo" src={cardanoLogoC1} />
                    <h1 className="Header">What it is</h1>
                    <p>Communitypool is a Cardano stake pool</p>
                    <p>Our purpose is to help perserve the Cardano ecosystem while also supporting charities</p>
                    <p>We do this by donating 25% of the pools rewards every month</p>
                    <em>
                        TICKER: <span>TBD</span>
                    </em>
                </div>
            </div>
        );
    }

    renderHowItWorksSection() {
        return (
            <div className="HowItWorksSectionWrapper">
                <div className="WrapperWrapper">
                    <h1 className="Header">How it works</h1>

                    <div className="Step1Wrapper">
                        <p className="Number">1</p>
                        <div className="Step1" onClick={() => this.props.history.push("/step1")}>
                            <p className="Paragraph">Get cardano</p>
                        </div>
                    </div>
                    <div className="Step2Wrapper">
                        <div className="Step2" onClick={() => this.props.history.push("/step2")}>
                            <p className="Paragraph">Stake at our pool</p>
                        </div>
                        <p className="Number">2</p>
                    </div>
                    <div className="Step3Wrapper">
                        <p className="Number">3</p>
                        <div className="Step3" onClick={() => this.props.history.push("/step3")}>
                            <p className="Paragraph">Help the community</p>
                        </div>
                    </div>
                    {/* <div className="Step4Wrapper">
                        <div className="Step4" onClick={() => this.props.history.push("/step4")}>
                            <p className="Paragraph">We offer free financial educational content</p>
                        </div>
                        <p className="Number">4</p>
                    </div> */}
                </div>
            </div>
        );
    }

    renderOurVisionSection() {
        return (
            <div className="OurVisionSectionWrapper">
                <h1>Our vision</h1>
                <div className="GeneralDescription">
                    <p>We believe that cryptocurrencies are a powerfull tool that enable the creation of meaningfull projetcs.</p>
                    <p>Our vision is to use these tools make your money work for you while helping others and also help you.</p>
                </div>
                <div className="Timeline">
                    <div className="rightbox">
                        <div className="rb-container">
                            <ul className="rb">
                                <li className="rb-item" ng-repeat="itembx">
                                    <div className="timestamp">Phase 1</div>
                                    <div className="item-title">We donate every month 25% of the pool's rewards, not yours, to different charities.</div>
                                </li>
                                <li className="rb-item" ng-repeat="itembx">
                                    <div className="timestamp">Phase 2</div>
                                    <div className="item-title">
                                        We start to give you our experience in the world of crypto by starting our podcast series. At the same time, various
                                        kinds of tools will be developed that may help you in your crypto journey.
                                    </div>
                                </li>
                                <li className="rb-item" ng-repeat="itembx">
                                    <div className="timestamp">Phase 3</div>
                                    <div className="item-title">
                                        Governance starts to be developed. Smart contracts on the Cardano network so that every delegator can vote to the
                                        monthly presented charities.
                                    </div>
                                </li>
                                <li className="rb-item" ng-repeat="itembx">
                                    <div className="timestamp">Phase 4</div>
                                    <div className="item-title">
                                        We start by inviting guests with experience in the world of crypto into our podcats and share their experiences with the
                                        community.
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderTeamMember(imageSrc: string, name: string, description: string, linkedinURL: string = "") {
        return (
            <div className="ItemWrapper">
                <div className="Left">
                    <img src={imageSrc} />
                    <p className="Name">{name}</p>
                    <div className="LinksWrapper">
                        {linkedinURL !== "" && <img className="Social" src={linkedinLogo} onClick={() => window.open(linkedinURL)} />}
                    </div>
                </div>
                <div className="Right">
                    <p>{description}</p>
                </div>
            </div>
        );
    }

    renderTheTeamSection() {
        return (
            <div className="TheTeamWrapper">
                <img className="Logo" src={cardanoLogoC2} />
                <h1 className="Header">The team</h1>
                <p className="Description">
                    We're a small team from Portugal made up of full blown crypto enthusiasts with a passion to really make a difference in helping the
                    community. We have, combined, years of experience in web development, systems administration and financial management.
                </p>
                <div className="ItemsWrapper">
                    {this.renderTeamMember(photoMiguel, "Miguel Vieira", "Descrição", "https://www.linkedin.com/in/miguel-vieira-694646192/")}
                    {this.renderTeamMember(photoNuno, "Nuno Durães", "Descrição", "https://www.linkedin.com/in/nunoduraes/")}
                    {this.renderTeamMember(photoVasco, "Vasco Sá", "Descrição", "https://www.linkedin.com/in/vasco-s%C3%A1-1848a91b6/")}
                    {this.renderTeamMember(photoLuis, "Luis Barrelas", "Descrição", "https://www.linkedin.com/in/luis-barrelas-571780154/")}
                </div>
            </div>
        );
    }

    renderDonationItem(name: string, photo: string, link: string) {
        return (
            <div
                className="ItemWrapper"
                onClick={() => {
                    window.open(link);
                }}
            >
                <div className="Top" style={{ backgroundImage: `url(${photo})` }} />
                <div className="Bottom">
                    <p>{name}</p>
                </div>
            </div>
        );
    }

    renderDonationsSection() {
        return (
            <div className="DonationsSectionWrapper">
                <h1>Where we donate</h1>
                <div className="FutureDonationsWrapper">
                    {this.renderDonationItem("Ripple Africa", photoDonation1, "https://rippleafrica.org/")}
                    {this.renderDonationItem("Ocean Conservancy", photoDonation2, "https://oceanconservancy.org/")}
                    {this.renderDonationItem("Forest & Bird", photoDonation3, "https://www.forestandbird.org.nz/")}
                </div>
                <div className="MadeDonationsWrapper">
                    <button onClick={() => this.props.history.push("/donations")}>Check donations</button>
                </div>
            </div>
        );
    }

    renderContactUsSection() {
        const { contactName, contactEmail, contactMessage } = this.state;
        return (
            <div className="ContactUsSectionWrapper">
                <h1>Contact us</h1>
                <div className="Form">
                    <input
                        placeholder={"Full name"}
                        value={contactName}
                        onChange={(e: any) => {
                            this.setState({ contactName: e.target.value });
                        }}
                    />
                    <input
                        placeholder={"Email"}
                        value={contactEmail}
                        onChange={(e: any) => {
                            this.setState({ contactEmail: e.target.value });
                        }}
                    />
                    <textarea
                        placeholder={"Message"}
                        value={contactMessage}
                        onChange={(e: any) => {
                            this.setState({ contactMessage: e.target.value });
                        }}
                    />
                    <button onClick={() => this.sendEmail()}>Send</button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="MainWrapper">
                {this.renderMainSection()}
                {this.renderWhatIsSection()}
                {this.renderOurVisionSection()}
                {this.renderHowItWorksSection()}
                {this.renderDonationsSection()}
                {this.renderTheTeamSection()}
                {this.renderContactUsSection()}
            </div>
        );
    }
}

export default withRouter(LandingPage);
